import React, { useState } from "react"

const ExternalLink = ({ href, clase = "", children }) => {
  const [showPopup, setShowPopup] = useState(false)
  const [pendingUrl, setPendingUrl] = useState("")

  const handleClick = (event) => {
    event.preventDefault() // Evita la navegación inmediata
    setPendingUrl(href)
    setShowPopup(true)
  }

  const handleContinue = () => {
    window.open(pendingUrl, "_blank")
    setShowPopup(false)
  }

  const handleCancel = () => {
    setShowPopup(false)
    setPendingUrl("")
  }

  return (
    <>
      <a href={href} className={clase} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
        {children}
      </a>

      {showPopup && (
        <div className="popup-overlay">
          <div className="modal-content">
            <div className="modal-header"><h5 className="modal-title">Saliendo del sitio</h5>
              <button onClick={handleCancel} type="button" className="close" data-dismiss="modal"
                      aria-label="Close"><span
                aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body"><p>Está a punto de salir del sitio web de Vector Casa de Bolsa, S.A. de C.V., y
              accederá a una página externa cuyo contenido no es responsabilidad Vector, ¿Desea continuar?</p></div>
            <div className="modal-footer">
              <button className="btn-cancel btn" onClick={handleCancel}>Cancelar</button>
              <button className="btn-continue btn" onClick={handleContinue}>Continuar</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1002;
        }
        .modal-content {
          position: relative;
          top: -160px;
          margin: 1.75rem auto;
          display: flex;
          flex-direction: column;
          width: 100%;
          pointer-events: auto;
          background-color: #fff;
          border: 1px solid rgba(0, 0, 0, .2);
          border-radius: .3rem;
          outline: 0;
          max-width: 1140px;
        }

        .modal-header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            padding: 1rem;
            border-bottom: 1px solid #dee2e6;
            border-top-left-radius: .3rem;
            border-top-right-radius: .3rem;
        }
        .modal-title {
            margin-bottom: 0;
            line-height: 1.5;
        }
        .modal-header .close {
            padding: 1rem;
            margin: -1rem -1rem -1rem auto;
        }
        button.close {
            padding: 0;
            background-color: transparent;
            border: 0;
            appearance: none;
        }
        .close {
            float: right;
            font-size: 1.3125rem;
            color: #000;
            text-shadow: 0 1px 0 #fff;
            opacity: .5;
        }
        .modal-body {
            position: relative;
            flex: 1 1 auto;
            padding: 1rem;
        }
        .modal-footer {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 1rem;
            border-top: 1px solid #dee2e6;
            border-bottom-right-radius: .3rem;
            border-bottom-left-radius: .3rem;
        }
        .modal-footer>:not(:last-child) {
            margin-right: .25rem;
        }
        .btn-secondary {
            color: #fff;
            background-color: #6c757d;
            border-color: #6c757d;
        }
        .btn {
            text-transform: uppercase;
            cursor: pointer;
            display: inline-block;
            color: #212529;
            text-align: center;
            vertical-align: middle;
            user-select: none;
            background-color: transparent;
            border: 1px solid transparent;
            padding: .375rem .75rem;
            font-size: .875rem;
            line-height: 1.5;
            border-radius: .25rem;
            transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        }
        .btn-continue{
        color: #fff;
            background-color: #495057;
            border-color: #495057;
        }
        .btn-cancel{
            color: #fff;
            background-color: #545b62;
            border-color: #4e555b;
        }
        h5 {
          text-transform: uppercase;
      }
      .close{
      cursor: pointer;
      }
      `}</style>
    </>
  )
}

export default ExternalLink
